<template>
	<input class="slider" :step="step" :min="min" :max="max" :value="value" type="range" @input="onInput">
</template>
<script>
	export default {
		props: {
			min: Number,
			max: Number,
			step: Number,
			value: {
				type: Number,
				default() {
					return this.max;
				}
			}
		},
		methods: {
			onInput(e) {
				this.$emit('input', Number.parseInt(e.target.value, 10));
			}
		}
	}
</script>
<style lang="scss" scoped>	

</style>
